import { render, staticRenderFns } from "./OrderStatusPreview.vue?vue&type=template&id=7aa885a0&"
import script from "./OrderStatusPreview.vue?vue&type=script&lang=ts&"
export * from "./OrderStatusPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports